// Indian Cities organized by State
export const INDIAN_CITIES_BY_STATE = {
    'Andhra Pradesh': [
      'Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Rajahmundry', 
      'Tirupati', 'Kakinada', 'Kadapa', 'Anantapur', 'Eluru', 'Ongole', 'Nandyal', 'Machilipatnam'
    ],
    'Arunachal Pradesh': [
      'Itanagar', 'Naharlagun', 'Pasighat', 'Tawang', 'Bomdila', 'Ziro', 'Along', 'Tezu'
    ],
    'Assam': [
      'Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon', 'Tinsukia', 'Tezpur', 
      'Sivasagar', 'Bongaigaon', 'Dhubri', 'Goalpara', 'Barpeta', 'Karimganj'
    ],
    'Bihar': [
      'Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia', 'Darbhanga', 'Arrah', 
      'Begusarai', 'Katihar', 'Munger', 'Chapra', 'Bettiah', 'Saharsa', 'Sasaram'
    ],
    'Chhattisgarh': [
      'Raipur', 'Bhilai', 'Bilaspur', 'Durg', 'Korba', 'Rajnandgaon', 'Raigarh', 
      'Jagdalpur', 'Ambikapur', 'Dhamtari', 'Chirmiri', 'Mahasamund'
    ],
    'Goa': [
      'Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda', 'Mormugao'
    ],
    'Gujarat': [
      'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Gandhinagar', 
      'Anand', 'Nadiad', 'Surendranagar', 'Bharuch', 'Mehsana', 'Bhuj', 'Porbandar'
    ],
    'Haryana': [
      'Faridabad', 'Gurgaon', 'Panipat', 'Ambala', 'Yamunanagar', 'Rohtak', 'Hisar', 
      'Karnal', 'Sonipat', 'Panchkula', 'Sirsa', 'Bhiwani', 'Jind', 'Bahadurgarh'
    ],
    'Himachal Pradesh': [
      'Shimla', 'Mandi', 'Solan', 'Dharamshala', 'Bilaspur', 'Kullu', 'Chamba', 
      'Kangra', 'Hamirpur', 'Una', 'Nahan', 'Palampur'
    ],
    'Jharkhand': [
      'Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Hazaribagh', 'Deoghar', 'Giridih', 
      'Ramgarh', 'Medininagar', 'Chaibasa', 'Jhumri Telaiya', 'Sahibganj'
    ],
    'Karnataka': [
      'Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum', 'Gulbarga', 'Davangere', 
      'Kozhikode', 'Shimoga', 'Tumkur', 'Raichur', 'Bijapur', 'Hassan', 'Udupi'
    ],
    'Kerala': [
      'Kochi', 'Thiruvananthapuram', 'Kozhikode', 'Thrissur', 'Kollam', 'Alappuzha', 
      'Palakkad', 'Kannur', 'Kottayam', 'Malappuram', 'Manjeri', 'Thalassery'
    ],
    'Madhya Pradesh': [
      'Bhopal', 'Indore', 'Gwalior', 'Jabalpur', 'Ujjain', 'Sagar', 'Ratlam', 
      'Satna', 'Rewa', 'Murwara', 'Singrauli', 'Chhindwara', 'Khandwa', 'Morena'
    ],
    'Maharashtra': [
      'Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Solapur', 
      'Amravati', 'Kolhapur', 'Sangli', 'Jalgaon', 'Akola', 'Latur', 'Ahmednagar'
    ],
    'Manipur': [
      'Imphal', 'Thoubal', 'Kakching', 'Ukhrul', 'Churachandpur', 'Bishnupur', 'Tamenglong'
    ],
    'Meghalaya': [
      'Shillong', 'Tura', 'Jowai', 'Nongstoin', 'Baghmara', 'Williamnagar', 'Resubelpara'
    ],
    'Mizoram': [
      'Aizawl', 'Lunglei', 'Saiha', 'Champhai', 'Kolasib', 'Serchhip', 'Lawngtlai'
    ],
    'Nagaland': [
      'Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha', 'Zunheboto', 'Mon'
    ],
    'Odisha': [
      'Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur', 'Puri', 
      'Baleshwar', 'Bhadrak', 'Baripada', 'Jharsuguda', 'Rayagada', 'Jeypore'
    ],
    'Punjab': [
      'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Pathankot', 
      'Hoshiarpur', 'Mohali', 'Batala', 'Moga', 'Abohar', 'Malerkotla', 'Khanna'
    ],
    'Rajasthan': [
      'Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara', 
      'Alwar', 'Bharatpur', 'Sikar', 'Tonk', 'Pali', 'Hanumangarh', 'Ganganagar'
    ],
    'Sikkim': [
      'Gangtok', 'Namchi', 'Mangan', 'Gyalshing', 'Singtam', 'Rangpo'
    ],
    'Tamil Nadu': [
      'Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 
      'Erode', 'Vellore', 'Thoothukudi', 'Dindigul', 'Thanjavur', 'Hosur', 'Nagercoil'
    ],
    'Telangana': [
      'Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Ramagundam', 'Khammam', 
      'Mahbubnagar', 'Nalgonda', 'Adilabad', 'Siddipet', 'Suryapet', 'Miryalaguda'
    ],
    'Tripura': [
      'Agartala', 'Udaipur', 'Dharmanagar', 'Kailasahar', 'Belonia', 'Khowai', 'Ambassa'
    ],
    'Uttar Pradesh': [
      'Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Allahabad', 'Meerut', 'Ghaziabad', 
      'Noida', 'Bareilly', 'Aligarh', 'Moradabad', 'Saharanpur', 'Gorakhpur', 'Faizabad'
    ],
    'Uttarakhand': [
      'Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur', 'Kashipur', 
      'Rishikesh', 'Pithoragarh', 'Almora', 'Nainital', 'Mussoorie'
    ],
    'West Bengal': [
      'Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri', 'Bardhaman', 
      'Malda', 'Kharagpur', 'Baharampur', 'Jalpaiguri', 'Krishnanagar', 'Cooch Behar'
    ],
    'Andaman and Nicobar Islands': [
      'Port Blair', 'Diglipur', 'Mayabunder', 'Rangat', 'Car Nicobar'
    ],
    'Chandigarh': [
      'Chandigarh'
    ],
    'Dadra and Nagar Haveli and Daman and Diu': [
      'Silvassa', 'Daman', 'Diu'
    ],
    'Delhi': [
      'New Delhi', 'Delhi', 'North Delhi', 'South Delhi', 'East Delhi', 'West Delhi'
    ],
    'Jammu and Kashmir': [
      'Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Sopore', 'Kathua', 'Udhampur'
    ],
    'Ladakh': [
      'Leh', 'Kargil'
    ],
    'Lakshadweep': [
      'Kavaratti', 'Agatti', 'Amini', 'Andrott'
    ],
    'Puducherry': [
      'Puducherry', 'Karaikal', 'Mahe', 'Yanam'
    ]
  };
  
  // Get cities for a specific state
  export const getCitiesByState = (state: string) => {
    return (INDIAN_CITIES_BY_STATE as { [key: string]: string[] })[state] || [];
  };
  
  // Get all cities (flat list)
  export const getAllCities = () => {
    return Object.values(INDIAN_CITIES_BY_STATE).flat();
  };
  
  export default INDIAN_CITIES_BY_STATE;
  